// extracted by mini-css-extract-plugin
export default {"snackbar":"Notification_snackbar__uvcRb","snackbar--success":"Notification_snackbar--success__LtMwF","snackbar--error":"Notification_snackbar--error__XUIdd"};